inputs-without-label-textarea
  textarea(class="form-control { opts.klass }" name="{ opts.name }" placeholder="{ opts.placeholder }" onInput="{this.onInput}" onChange="{this.onChange}") { opts.value }
  div.help-block(if="{ opts.errors }")
    ul(role="alert")
      li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.textarea');
